import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import TypeIcon from '../editor/TypeIcon';
import {stripHtml} from '../../../utils/text';

const PageHeader = ({item}) => (
    <>
        <div className="question-id">
            {item.items[0].id}
        </div>
        <div className="question-type border-left">
            <TypeIcon type={item.items[0].type} />
        </div>
        <div className="page-header border-left d-flex flex-column justify-content-center">
            {stripHtml(item.items[0].title || item.items[0].text) || (
                <div className="missing"><FormattedMessage {...messages.surveys.form.label.missingText} /></div>
            )}
            <div>{item.items[0].subtitle}</div>
        </div>
    </>
);

export default PageHeader;
